export default __webpack_public_path__ + "static/media/Background 5_00053.382a0bd5.png";